<template>
  <cms-types />
</template>

<script>
export default {
  components: {
    CmsTypes: () => import('@/components/cms/types/CmsTypes'),
  },
}
</script>